import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {supplierSpendSummaryUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {SupplierSpendSummary} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * Spend breakdown for one entity (`GET supplier_360/entity/{id}/spend_summary/`).
 * A plain aggregate action, not a paginated list — the response is the object itself.
 */
export function useSupplierSpendSummaryQuery(entityId: number | undefined) {
    const url = supplierSpendSummaryUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<SupplierSpendSummary>(url)).data,
        enabled: Boolean(entityId),
    });
}
